export const GET_USER_FOLLOWUPS = 'followUps/GET_USER_FOLLOWUPS'
export const GET_USER_FOLLOWUP_COUNT = 'followUps/GET_USER_FOLLOWUP_COUNT'
export const RESET_STORE = 'followUps/RESET_STORE'
